import { is, map } from 'ramda';
const trimString = (string) => {
    return string.trim();
};
const trimIteratable = (iteratable) => {
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return map(trimValues, iteratable);
};
const trimValues = (value) => {
    if (is(String, value)) {
        return trimString(value);
    }
    if (is(Array, value) || is(Object, value)) {
        return trimIteratable(value);
    }
    return value;
};
export default trimValues;
//# sourceMappingURL=trimValues.js.map